<script lang="ts">
    import {Component, Prop, toNative} from 'vue-facing-decorator'
    import Daterange, {Daterange as _Daterange} from '~/components/search/forms/Daterange.vue'

    @Component({mixins: [Daterange]})
    export class OrderCreateDaterange extends _Daterange {
        @Prop({default: () => undefined}) minStartDate

        checkEndDate(newStartDate) {
            if (this.endDate && newStartDate > this.endDate) {
                const differenceInDays = this.$dateFns.differenceInDays(this.endDate, this.startDate)
                const newEndDate = this.$dateFns.addDays(newStartDate, differenceInDays)
                if (this.maxEndDate && newEndDate > this.maxEndDate) {
                    this.endDate = this.maxEndDate
                } else {
                    this.endDate = newEndDate
                }
            }
        }

        onChangeStartDate(newStartDate) {
            this.startDate = newStartDate
            this.showStartDatePicker = false
            this.checkEndDate(newStartDate)
            this.onStartDateBlur()
        }

        get maxStartDate() {
            return new Date()
        }

        get minEndDate() {
            return this.startDate
        }

        get maxEndDate() {
            return new Date()
        }
    }

    export default {...toNative(OrderCreateDaterange), ssrRender: Daterange.ssrRender}
</script>
